<template>
  <button
    :class="theClass"
    v-on="$listeners"
  >
    <slot></slot>
  </button>
</template>

<script>
/* eslint-disable */
export default {
  name: 'VuePlayerButton',

  props: {
    show: Boolean
  },

  computed: {
    theClass() {
      if (this.$attrs.class) return this.$attrs.class

      return 'vue-player-button'
    }
  }
}
</script>

<style scoped lang="scss">
.vue-player-button {
  width: 35px;
  border: 0px solid white;
  color: white;
  background-color: transparent;
  outline: 0px;
}
</style>
